import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgSpinner from './svg';
import design from './design';

const inlineStyle = {
  display: 'inline-block',
  verticalAlign: 'middle',
  marginRight: 6
};

/**
 * Display a spinner.
 *
 * @displayName Spinner (Web)
 * @class Spinner
 * @public
 */
export default class Spinner extends Component {
  /**
   * Return a label element if we need to render one.
   *
   * @returns {Component} Label
   * @private
   */
  label() {
    const props = this.props;

    if (!props.label) return null;

    if (typeof props.label === 'string') return (
      <label className='ux-spinner-label'>
        { props.label }
      </label>
    );

    return props.label;
  }

  /**
   * Render the actual component.
   *
   * @returns {Component} The actual spinner component.
   * @private
   */
  render() {
    const { inline, shade, size } = this.props;
    const styles = design(size, shade);
    const spinnerStyle = {
      width: styles.size.width
    };

    // Remark (crobbins): style prop in React must be an object.
    const outerStyle = inline ? inlineStyle : {};

    return (
      <div style={ outerStyle } className={ this.props.className }>
        <div style={{ display: 'inline-block' }} >
          <div style={ spinnerStyle } className='ux-spinner' >
            <SvgSpinner shade={ shade } size={ size } />
          </div>
          { this.label() }
        </div>
      </div>
    );
  }
}

Spinner.propTypes = {
  /** Classes to be applied to the spinner */
  className: PropTypes.string,
  /** Determines whether the spinner will be displayed inline or not */
  inline: PropTypes.bool,
  /** The label for the spinner */
  label: PropTypes.node,
  /** Defines the shade of the spinner */
  shade: PropTypes.oneOf(['light', 'primary', 'dark']).isRequired,
  /** Defines the size of the spinner */
  size: PropTypes.PropTypes.oneOf(['sm', 'md', 'lg']).isRequired
};

/**
 * Default properties.
 *
 * @type {Object}
 * @private
 */
Spinner.defaultProps = {
  ...SvgSpinner.defaultProps,
  ...{ className: 'spin-center' }
};
